export class DietTypeModel {
  constructor(
    private engName: string,
    private name: string,
    private id: number,
    private img: string
  ) {}

  public getName() {
    return this.name;
  }

  public getID() {
    return this.id;
  }

  public getEngName() {
    return this.engName;
  }

  public getImg() {
    return this.img;
  }
}

const WeightLoss = new DietTypeModel(
  'weightLoss',
  'لاغری',
  0,
  'assets/generate/Thin.png'
);
const WeightFix = new DietTypeModel(
  'weightFix',
  'تثبیت',
  1,
  'assets/generate/Stable.png'
);
const WeightGain = new DietTypeModel(
  'weightGain',
  'چاقی',
  2,
  'assets/generate/Fat.png'
);
const Pregnancy = new DietTypeModel(
  'pregnancy',
  'بارداری',
  3,
  'assets/generate/Pregnancy.png'
);
const Breastfeeding = new DietTypeModel(
  'breastfeeding',
  'شیردهی',
  4,
  'assets/generate/Breastfeeding.png'
);

export const WomanDietTypes = [
  WeightLoss,
  WeightFix,
  WeightGain,
  Pregnancy,
  Breastfeeding,
];
export const ManDietTypes = [WeightLoss, WeightFix, WeightGain];
export const FastingDietTypes = [WeightLoss, WeightFix];
